package linkerpangoquipdb

import app.cash.sqldelight.ExecutableQuery
import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Double
import kotlin.Long
import kotlin.String

public class MaintenanceQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> select_by_id(id: Long, mapper: (
    id: Long,
    server_id: Long?,
    vehicle_vin: String,
    kilometers: Long,
    mechanic: String,
    workshop: String,
    description: String,
    date: Long,
    cost: Double,
    signature: String?,
  ) -> T): Query<T> = Select_by_idQuery(id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1),
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getLong(7)!!,
      cursor.getDouble(8)!!,
      cursor.getString(9)
    )
  }

  public fun select_by_id(id: Long): Query<Maintenance> = select_by_id(id, ::Maintenance)

  public fun <T : Any> select_by_server_id(server_id: Long?, mapper: (
    id: Long,
    server_id: Long?,
    vehicle_vin: String,
    kilometers: Long,
    mechanic: String,
    workshop: String,
    description: String,
    date: Long,
    cost: Double,
    signature: String?,
  ) -> T): Query<T> = Select_by_server_idQuery(server_id) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1),
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getLong(7)!!,
      cursor.getDouble(8)!!,
      cursor.getString(9)
    )
  }

  public fun select_by_server_id(server_id: Long?): Query<Maintenance> = select_by_server_id(server_id, ::Maintenance)

  public fun <T : Any> select_by_vehicle_vin(vehicle_vin: String, mapper: (
    id: Long,
    server_id: Long?,
    vehicle_vin: String,
    kilometers: Long,
    mechanic: String,
    workshop: String,
    description: String,
    date: Long,
    cost: Double,
    signature: String?,
  ) -> T): Query<T> = Select_by_vehicle_vinQuery(vehicle_vin) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1),
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getLong(7)!!,
      cursor.getDouble(8)!!,
      cursor.getString(9)
    )
  }

  public fun select_by_vehicle_vin(vehicle_vin: String): Query<Maintenance> = select_by_vehicle_vin(vehicle_vin, ::Maintenance)

  public fun <T : Any> select_all(mapper: (
    id: Long,
    server_id: Long?,
    vehicle_vin: String,
    kilometers: Long,
    mechanic: String,
    workshop: String,
    description: String,
    date: Long,
    cost: Double,
    signature: String?,
  ) -> T): Query<T> = Query(-341_738_740, arrayOf("maintenance"), driver, "Maintenance.sq", "select_all", "SELECT maintenance.id, maintenance.server_id, maintenance.vehicle_vin, maintenance.kilometers, maintenance.mechanic, maintenance.workshop, maintenance.description, maintenance.date, maintenance.cost, maintenance.signature FROM maintenance") { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1),
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5)!!,
      cursor.getString(6)!!,
      cursor.getLong(7)!!,
      cursor.getDouble(8)!!,
      cursor.getString(9)
    )
  }

  public fun select_all(): Query<Maintenance> = select_all(::Maintenance)

  public fun last_insert_rowid(): ExecutableQuery<Long> = Query(-861_757_558, driver, "Maintenance.sq", "last_insert_rowid", "SELECT last_insert_rowid()") { cursor ->
    cursor.getLong(0)!!
  }

  public fun select_distinct_mechanics(): Query<String> = Query(-1_498_440_927, arrayOf("maintenance"), driver, "Maintenance.sq", "select_distinct_mechanics", "SELECT DISTINCT mechanic FROM maintenance WHERE mechanic != 'N/A' AND mechanic != '' ORDER BY mechanic ASC") { cursor ->
    cursor.getString(0)!!
  }

  public fun select_distinct_workshops(): Query<String> = Query(-1_614_890_626, arrayOf("maintenance"), driver, "Maintenance.sq", "select_distinct_workshops", "SELECT DISTINCT workshop FROM maintenance WHERE workshop != 'N/A' AND workshop != '' ORDER BY workshop ASC") { cursor ->
    cursor.getString(0)!!
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertMaintenance(
    server_id: Long?,
    vehicle_vin: String,
    date: Long,
    kilometers: Long,
    description: String,
    mechanic: String,
    workshop: String,
    cost: Double,
    signature: String?,
  ): Long {
    val result = driver.execute(2_018_529_196, """
        |INSERT INTO maintenance(server_id, vehicle_vin, date, kilometers, description, mechanic, workshop, cost, signature)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 9) {
          var parameterIndex = 0
          bindLong(parameterIndex++, server_id)
          bindString(parameterIndex++, vehicle_vin)
          bindLong(parameterIndex++, date)
          bindLong(parameterIndex++, kilometers)
          bindString(parameterIndex++, description)
          bindString(parameterIndex++, mechanic)
          bindString(parameterIndex++, workshop)
          bindDouble(parameterIndex++, cost)
          bindString(parameterIndex++, signature)
        }.await()
    notifyQueries(2_018_529_196) { emit ->
      emit("maintenance")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertMaintenanceWithId(
    id: Long?,
    server_id: Long?,
    vehicle_vin: String,
    date: Long,
    kilometers: Long,
    description: String,
    mechanic: String,
    workshop: String,
    cost: Double,
    signature: String?,
  ): Long {
    val result = driver.execute(767_322_957, """
        |INSERT OR REPLACE INTO maintenance(id, server_id, vehicle_vin, date, kilometers, description, mechanic, workshop, cost, signature)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 10) {
          var parameterIndex = 0
          bindLong(parameterIndex++, id)
          bindLong(parameterIndex++, server_id)
          bindString(parameterIndex++, vehicle_vin)
          bindLong(parameterIndex++, date)
          bindLong(parameterIndex++, kilometers)
          bindString(parameterIndex++, description)
          bindString(parameterIndex++, mechanic)
          bindString(parameterIndex++, workshop)
          bindDouble(parameterIndex++, cost)
          bindString(parameterIndex++, signature)
        }.await()
    notifyQueries(767_322_957) { emit ->
      emit("maintenance")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun update(
    server_id: Long?,
    vehicle_vin: String,
    kilometers: Long,
    mechanic: String,
    workshop: String,
    description: String,
    date: Long,
    cost: Double,
    signature: String?,
    id: Long,
  ): Long {
    val result = driver.execute(1_010_399_991, """UPDATE maintenance SET server_id = ?, vehicle_vin = ?, kilometers = ?, mechanic = ?, workshop = ?, description = ?, date = ?, cost = ?, signature = ? WHERE id = ?""", 10) {
          var parameterIndex = 0
          bindLong(parameterIndex++, server_id)
          bindString(parameterIndex++, vehicle_vin)
          bindLong(parameterIndex++, kilometers)
          bindString(parameterIndex++, mechanic)
          bindString(parameterIndex++, workshop)
          bindString(parameterIndex++, description)
          bindLong(parameterIndex++, date)
          bindDouble(parameterIndex++, cost)
          bindString(parameterIndex++, signature)
          bindLong(parameterIndex++, id)
        }.await()
    notifyQueries(1_010_399_991) { emit ->
      emit("maintenance")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun delete_by_id(id: Long): Long {
    val result = driver.execute(-498_035_171, """DELETE FROM maintenance WHERE id = ?""", 1) {
          var parameterIndex = 0
          bindLong(parameterIndex++, id)
        }.await()
    notifyQueries(-498_035_171) { emit ->
      emit("maintenance")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun delete_all(): Long {
    val result = driver.execute(-1_216_160_709, """DELETE FROM maintenance""", 0).await()
    notifyQueries(-1_216_160_709) { emit ->
      emit("maintenance")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun delete_by_vehicle_vin(vehicle_vin: String): Long {
    val result = driver.execute(-93_746_746, """DELETE FROM maintenance WHERE vehicle_vin = ?""", 1) {
          var parameterIndex = 0
          bindString(parameterIndex++, vehicle_vin)
        }.await()
    notifyQueries(-93_746_746) { emit ->
      emit("maintenance")
    }
    return result
  }

  private inner class Select_by_idQuery<out T : Any>(
    public val id: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("maintenance", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("maintenance", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-1_992_112_978, """SELECT maintenance.id, maintenance.server_id, maintenance.vehicle_vin, maintenance.kilometers, maintenance.mechanic, maintenance.workshop, maintenance.description, maintenance.date, maintenance.cost, maintenance.signature FROM maintenance WHERE id = ?""", mapper, 1) {
      var parameterIndex = 0
      bindLong(parameterIndex++, id)
    }

    override fun toString(): String = "Maintenance.sq:select_by_id"
  }

  private inner class Select_by_server_idQuery<out T : Any>(
    public val server_id: Long?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("maintenance", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("maintenance", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(null, """SELECT maintenance.id, maintenance.server_id, maintenance.vehicle_vin, maintenance.kilometers, maintenance.mechanic, maintenance.workshop, maintenance.description, maintenance.date, maintenance.cost, maintenance.signature FROM maintenance WHERE server_id ${ if (server_id == null) "IS" else "=" } ?""", mapper, 1) {
      var parameterIndex = 0
      bindLong(parameterIndex++, server_id)
    }

    override fun toString(): String = "Maintenance.sq:select_by_server_id"
  }

  private inner class Select_by_vehicle_vinQuery<out T : Any>(
    public val vehicle_vin: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("maintenance", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("maintenance", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> = driver.executeQuery(-1_817_956_779, """SELECT maintenance.id, maintenance.server_id, maintenance.vehicle_vin, maintenance.kilometers, maintenance.mechanic, maintenance.workshop, maintenance.description, maintenance.date, maintenance.cost, maintenance.signature FROM maintenance WHERE vehicle_vin = ?""", mapper, 1) {
      var parameterIndex = 0
      bindString(parameterIndex++, vehicle_vin)
    }

    override fun toString(): String = "Maintenance.sq:select_by_vehicle_vin"
  }
}
